import { HttpClient } from '@angular/common/http';
import { Component, CUSTOM_ELEMENTS_SCHEMA, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { ApisService } from '@core/services/apis.service';
import { TranslateService } from '@ngx-translate/core';
import {
  ColumnMode,
  SelectionType,
  DatatableComponent,
} from "@swimlane/ngx-datatable";
import { ToastrService } from 'ngx-toastr';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-contracts-type',
  templateUrl: './contracts-type.component.html',
  styleUrls: ['./contracts-type.component.scss'],
        encapsulation: ViewEncapsulation.None
})
export class ContractsTypeComponent implements OnInit {

  public ads: any[] = [];
  public messages: any = {};

  constructor( 
    private apisService: ApisService,
    // private loadingService: Loadingscr,
    private router: Router,
        private toastr : ToastrService,
         private translate: TranslateService
  ) {} 
    public pages  : any
    public totalItems = 0;
  public currentPage = 1; 
  public itemsPerPage = 10;

  public tempData = [];

  @ViewChild(DatatableComponent) table: DatatableComponent;

  public ColumnMode = ColumnMode;
  public SelectionType = SelectionType;v

 ngOnInit(): void {

  

                this.getTags();

   this.setDatatableMessages(); // set initial messages

    // listen for language change dynamically
    this.translate.onLangChange.subscribe(() => {
      this.setDatatableMessages();
    });

  }

   private setDatatableMessages() {
    this.messages = {
      totalMessage: this.translate.instant('MENU.DASHBOARD.total')
    };
  }


 /*----------  Handling image Error  ----------*/
 onImageError(event) {
  event.target.src = 'assets/images/logo/12.png';
 }

  
             getTags(){ 
  this.apisService.contractsType().subscribe({
    next: (response: any) => {
      // The actual array is in response.data.data
      this.pages = response.data;  

      this.totalItems = this.pages.length;
      console.log("pages:", this.pages);
    },
    error: (error: any) => {
      console.log(error);
    }
  }
    
  )
 }
 

  addCoupon() {
    this.router.navigate(["main/coupons/add-coupon"]);
  }

  

 

  filterUpdate(event) {
    const val = event.target.value.toLowerCase();
    this.ads = this.tempData.filter((d) =>
      d.code.toLowerCase().includes(val)
    );
    this.table.offset = 0;
  }


  confirmDelete(id: any) {
  Swal.fire({
    title: this.translate.instant('MENU.DASHBOARD.CONFIRM_DELETE_TITLE'),
    text: this.translate.instant('MENU.DASHBOARD.CONFIRM_DELETE_TEXT'),
    icon: 'warning',
    showCancelButton: true,
    confirmButtonText: this.translate.instant('MENU.DASHBOARD.YES_DELETE'),
    cancelButtonText: this.translate.instant('MENU.DASHBOARD.CANCEL')
  }).then((result) => {
    if (result.isConfirmed) {
      this.deleteProduct(id);
    }
  });
}

   /*----------  deleting   ----------*/
 deleteProduct(id:any){ 
  this.apisService.DeleteContractstype(id).subscribe({
    next: (response: any) => {
    this.toastr.success(
        this.translate.instant('MENU.DASHBOARD.DELETED_SUCCESSFULLY')
      );      this.getTags();
    },
    error: (error: any) => {
      console.log(error);
   this.toastr.error(
        this.translate.instant('MENU.DASHBOARD.SOMETHING_WENT_WRONG')
      );
    }
  }
    
  )
 } 

editProduct(productId: number) {
  this.router.navigate(['/edit-contracts-type', productId]);
}



viewDetails(productId: number) {
  this.router.navigate(['/investors-details', productId]);

}
}
